export const visit = (vm, at) => {
at({ "de": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "Es gab ein Problem mit der Netzwerkverbindung.", "message": "Bitte \xFCberpr\xFCfen Sie Ihre Verbindung und versuchen Sie es erneut.", "button": "Erneut versuchen" } } } } });
};